import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToolbarModule } from 'primeng/toolbar';
import { TableModule } from 'primeng/table';
import { MenuModule } from 'primeng/menu';
import { AccordionModule } from 'primeng/accordion';
import { ToastModule } from 'primeng/toast';
import { SharedModule } from 'primeng/api';

import { TranslateModule } from '@ngx-translate/core';
import { PrimengSharedModule } from '@hvlng/framework-core/shared';

import { HvlFormItemModule, HvlFormMessageModule } from '@hvlng/framework-core/form';
import { UiKovanSharedModule, UiPageHeaderModule, UiSharedModule } from 'ui-shared';
import { OrganizationPickerComponent } from './component/organization-picker.component';
import { OrganizationSelectionListComponent } from './component/organization-selection-list.component';
import { OrganizationSelectionSearchFormComponent } from './component/organization-selection-search-form.component';
import { ChipModule } from 'primeng/chip';
import { InputGroupModule } from 'primeng/inputgroup';

@NgModule({
    declarations: [
        OrganizationPickerComponent,
        OrganizationSelectionListComponent,
        OrganizationSelectionSearchFormComponent,
    ],

    exports: [
        OrganizationPickerComponent,
        OrganizationSelectionListComponent,
        OrganizationSelectionSearchFormComponent,
    ],
    imports: [
        CommonModule,

        PrimengSharedModule,
        ReactiveFormsModule,
        HvlFormItemModule,
        ToolbarModule,
        UiPageHeaderModule,
        TableModule,
        MenuModule,
        AccordionModule,
        UiSharedModule,
        TranslateModule,
        ToastModule,
        FormsModule,
        SharedModule,
        HvlFormMessageModule,
        UiKovanSharedModule,
        ChipModule,
        InputGroupModule,
    ],
})
export class OrganizationSelectionModule {}
